import { render } from "./CustomerAndOrderNotesDetails.vue?vue&type=template&id=63875e2a"
import script from "./CustomerAndOrderNotesDetails.vue?vue&type=script&lang=js"
export * from "./CustomerAndOrderNotesDetails.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\php\\Resturant-POS-PHP-VUE-MODULE\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__